<div class="ui-checkbox" [class.checkbox--small]="size === 'small'" [ngClass]="{'ui-checkbox--tag': tag}"
>
  <input
    [id]="id"
    [name]="name"
    type="checkbox"
    class="ui-checkbox__input"
    [value]="value"
    [required]="required"
    [disabled]="disabled"
    [checked]="checked"
    (change)="onCheckboxChange($event)"
    [attr.aria-describedby]="input?.ariaDescribedby"
    [attr.aria-labelledby]="input?.ariaLabelledby"
    [attr.aria-hidden]="input?.ariaHidden"
  />
  <label [for]="id" class="ui-checkbox__label">
    <ng-content></ng-content>
  </label>
</div>
